<template>
  <div class="animated fadeIn">
    <b-card class="journal-box" no-body>
      <v-client-table :columns="columns" :data="items" :options="options">
        <div slot="utilisateur_id" slot-scope="props">
          <span style="color: #1c00ff" v-if="!isEmpty(props.row.original_user_id) && props.row.original_user_id !== props.row.utilisateur_id">
            {{ props.row.utilisateur_original }} en tant que {{ props.row.utilisateur }}
          </span>
          <span style="color: #1c00ff" v-if="!isEmpty(props.row.original_user_id) && props.row.original_user_id === props.row.utilisateur_id">
            {{ props.row.utilisateur_original }}
          </span>
          <span style="color: #f85844" v-if="isEmpty(props.row.original_user_id) && !isEmpty(props.row.beneficiaire_id)">
            {{ props.row.beneficiaire }}
          </span>
        </div>
        <div v-if="props.row.created_at" slot="created_at" slot-scope="props">
          <span class="badge badge-success p-2">{{ getFormattedDateTime(props.row.created_at) }}</span>
        </div>
        <div v-if="props.row.utilisateur_ip" slot="utilisateur_ip" slot-scope="props" class="slot-number">
          <span>{{ props.row.utilisateur_ip }}</span>
        </div>
        <div v-if="props.row.objet" slot="objet" slot-scope="props">
            <span v-if="props.row.action.includes('Téléchargement du décompte')">
              <a class="" href="#" @click.prevent="seeDetails(props.row)">{{ props.row.objet }}</a>
            </span>
          <span v-else>
              {{ props.row.objet }}
            </span>
        </div>
      </v-client-table>
    </b-card>
  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken} from '@/utils/auth';
  import {isEmpty} from "@/utils/fileHelper";
  import { formatDateTime } from "@/utils/communHelper";

  export default {
    name: "JournalBeneficiaire",
    props: ['benefId'],
    data() {
      return {
        columns: [
          "created_at",
          "utilisateur_id",
          "utilisateur_ip",
          "action",
          "objet"
        ],
        items: [],
        options: {
          headings: {
            created_at: "Date / Heure",
            utilisateur_id: "Utilisateur",
            utilisateur_ip: "Adresse IP",
            action: "Type d'action",
            objet: "Détail",
          },
          columnsClasses: {
            created_at: "date-header",
          },
          sortable: ["original_user_id", "action", "created_at"],
          filterable: ["original_user_id", "action"],
          perPage: 30,
          perPageValues: [30, 200, 500],
          texts: {
            filterPlaceholder: "Utilisateur, Action"
          }
        },
        isEmpty,
      }
    },
    mounted() {
      this.$event.on('refreshBeneficiaire', () => {
        this.getJournalByBeneficiaireId();
      });
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      getFormattedDateTime(textDate) {
        return formatDateTime(textDate, '/');
      },
      handleErrors() {
        this.$store.commit('IS_LOADING', false);
        this.$swal({
          position: 'top',
          type: 'warning',
          title: 'Attention !!',
          text: 'Une erreur système est survenue, si le problème persiste merci de faire un ticket au support DOSI',
          showConfirmButton: false,
          timer: 4000,
        });
      },
      seeDetails(element) {
        // console.log('element : ', element);
      },
      getJournalByBeneficiaireId() {
        let self = this;
        this.items = [];
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get("/espaceBeneficiaire/journal/getJournalByBeneficiaireId/" + this.$route.params.id)
          .then(response => {
            self.$store.commit("IS_LOADING", false);
            self.items = response.data.journal;
          })
          .catch(() => {
            self.$store.commit("IS_LOADING", false);
          });
      },
    }
  }
</script>
<style scoped>
  .journal-box {
    border: none !important;
  }
</style>
